/**
 * Converts only number-like strings: "0" | "1"
 * @param value
 */
export const convertStringToBoolean = (value: string | undefined): boolean => {
    return Boolean(Number(value));
};
